import classNames from 'classnames';
import React from 'react';
import Markdown from 'react-markdown';

import {
	BarryChart,
	type VisualizationData,
} from '~components/business-owner/barry/chart/BarryChart';

import { DarkBarryIcon } from '~assets/images';

import styles from './BarryIndividualConversation.module.scss';

interface BarryAssistantMessageBubbleProps {
	content: string;
	visualization?: VisualizationData | null;
	isItalic?: boolean;
}

export const BarryAssistantMessageBubble: React.FC<BarryAssistantMessageBubbleProps> = (
	props,
) => {
	const { content, visualization, isItalic = false } = props;

	return (
		<div className={classNames(styles.messageRow, styles.assistant)}>
			<div className={styles.avatar}>
				<DarkBarryIcon />
			</div>
			<div
				className={styles.messageBubble}
				style={isItalic ? { fontStyle: 'italic' } : undefined}
			>
				<Markdown>{content}</Markdown>
				{visualization && <BarryChart visualization={visualization} />}
			</div>
		</div>
	);
};
